module.exports = __webpack_public_path__ + "static/media/oil.a27915b7.png";